import axios from 'axios';
import { CATEGORY_LIST } from '../../../constants';

export const fetchCategoryList = (type, onError, isJobForm) => (dispatch) => {
  const token = localStorage.jwtToken;
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  dispatch(loadCategoryList());

  const url = isJobForm
    ? `/jobs/listCategory?isNewJobForm=${true}&type=${type}`
    : `/jobs/listCategory?type=${type}`;

  axios
    .get(url, config)
    .then((res) => dispatch(setCategoryList(res)))
    .catch((err) => {
      dispatch(errorCategoryList(err.response));
      onError(err.response);
    });
};

export const loadCategoryList = () => ({
  type: CATEGORY_LIST.LOAD,
});

export const setCategoryList = (categoryList) => ({
  type: CATEGORY_LIST.SUCCESS,
  payload: categoryList.data.data,
});

export const errorCategoryList = (error) => ({
  type: CATEGORY_LIST.FAIL,
  payload: error,
});
